<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For my wonderful grandchildren Olivia, Annie and Arthur</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<img alt="" src="images/elephant.jpg"/>
</div>
</div>
<p class="subsq dedication-content"><i>‘You make the world a little softer</i></p>
<p class="subsq dedication-content"><i>A little kinder</i></p>
<p class="subsq dedication-content"><i>A little warmer.’</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2c77c800